// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2bMYa","capitilize":"styles_capitilize__2HyYX","description":"styles_description__2D-B7"};